import { createSlice } from '@reduxjs/toolkit';

const initialState = {  
  lastConditionalSelectionSell: '',  
  sellStrategy: '',  
  isExpressionSellCorrect: false,
  sellSelectedItems: '',
  sellExpressionValidation:'',
  sellConditions: [
    { operand1: null, operator: null, operand2: null, conditional: null, enabled: true, operand2Options: [] }
  ]
};

const sellStrategySettingsSlicer = createSlice({
  name: 'sellStrategySettings',
  initialState,
  reducers: {    
    setLastConditionalSelectionSell: (state, action) => {
      state.lastConditionalSelectionSell = action.payload;
    },    
    setSellStrategy: (state, action) => {
      state.sellStrategy = action.payload;
    },    
    setIsExpressionSellCorrect: (state, action) => {
      state.isExpressionSellCorrect = action.payload;
    },
    setSellSelectedItems: (state, action) => {
      state.sellSelectedItems = action.payload;
    },
    setSellExpressionValidation: (state, action) => {
      state.sellExpressionValidation = action.payload;
    },
    setSellConditions: (state, action) => {
      if (Array.isArray(action.payload)) {
        state.sellConditions = action.payload;
      } else if (action.payload.index !== undefined && action.payload.field && action.payload.value !== undefined) {
        const { index, field, value } = action.payload;
        if (state.sellConditions[index]) {
          state.sellConditions[index] = { ...state.sellConditions[index], [field]: value };
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase('reset', () => initialState);
  }
});

export const {  
  setLastConditionalSelectionSell,  
  setSellStrategy,  
  setIsExpressionSellCorrect,
  setSellConditions, setSellSelectedItems, setSellExpressionValidation
} = sellStrategySettingsSlicer.actions;
export default sellStrategySettingsSlicer.reducer;